import React from 'react'
import LocationSvg from './location-svg'

const LocationTile = ({ location, activeLocationId, onHandleLocationClick }) => {
    const isActive = activeLocationId === location.uuid

    const handleLocationKeyDown = (e, locationId) => {
        // Handle Enter or Space key press
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault()
            onHandleLocationClick(locationId)
        }
    }

    return (
        <div
            tabIndex="0"
            role="button"
            aria-label={`Explore ${location.title}`}
            data-id={`${location.title}`}
            onKeyDown={(e) => handleLocationKeyDown(e, location.uuid)}
            onClick={() => onHandleLocationClick(location.uuid)}
            className={`location-box location-${location.displayOrder} ${activeLocationId ? isActive ? 'active' : 'inactive' : ''}`}>
            <LocationSvg location={location} />
            <div className="background">
                <img src={location.dashboardImage?.url} alt={location.dashboardImage?.alt} />
            </div>
            <div className="location-name">
                <span>{location.title}</span>
            </div>
        </div>
    )
}

export default LocationTile
